import * as React from 'react';
import Select from 'react-select';
import Creatable from 'react-select/creatable';
import './Campaign.css';
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker";
import {Campaign, MediaType} from '../../_models/Campaign'
import {User} from '../../_models/User'
import {Client} from '../../_models/Client'
import { toast } from 'react-toastify';
import CampaignUser from './popups/CampaignUser'
import CampaignUserLinks from './popups/CampaignUserLinks'
import "react-datepicker/dist/react-datepicker.css";
import {themeStyles, customSelectStyles} from './themeStyles.js'
import * as controller from './controller'
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import { withLocalize, Translate } from "react-localize-redux";




class CampaignPage extends React.Component<any, any> {

  handleCampaignChange: any
  handleSelectChange: any
  updateCampaign:any
  brief: any
  logo: any
  images: any[]
  image: any
  searchString: any

  constructor(props: any) {
    super(props);
    this.state = {
      campaign: new Campaign(),
      campaignUserPopupOpen: false,
      campaignUserLinksPopupOpen: false,
      clients: [],
      logo: "",
      brief: "",
      updating: false,
      userId: 0,
      usersFiltered: [],
      users: [],
      categories: [],
      selectedCategory: null,
      admins: [],
      tagValue: "",
      mediaTypes: [{
        value: "facebook",
        label: MediaType.facebook
      }, {
        value: "youtube",
        label: MediaType.youtube
      }, {
        value: "instagram",
        label: MediaType.instagram
      }]
    }
    this.updateCampaign = controller.updateCampaign.bind(this)
    this.handleCampaignChange = controller.handleCampaignChange.bind(this)
    this.renderCellInput = this.renderCellInput.bind(this)
    this.images = []
  }



  componentDidMount() {
    if(this.props.match.params.id && !isNaN(this.props.match.params.id)) {
      this.loadCampaign(this.props.match.params.id)
    }
    this.loadClients()
    this.loadUsers()
    this.loadAdmins()
    this.loadCategories()

  }

  search() {
      let usersFiltered = this.state.campaign.users.filter((user: any) => {
        return user.name.includes(this.searchString.value.trim())
      })
      this.setState({usersFiltered})
  }

  openPopup(popupName: string, userId: number) {
    this.setState({userId}, () => {
      this.setState({[popupName]: true})
    })
  }

  closePopup() {
    let campaign = this.state.campaign
    campaign.updated = false
    this.setState({campaign, campaignUserPopupOpen:false, campaignUserLinksPopupOpen: false})
  }

  loadCampaign(id:any) {
    fetch('campaigns/get', {
      method: 'POST',
      body: JSON.stringify({id})
    }).then(results => {
      return results.json();
    }).then(data => {
        let campaign = new Campaign(data.campaign)
        console.log(campaign)
        this.setState({campaign, usersFiltered: campaign.users})
    }).catch(err => {
      toast.error(err.message);
    })
  }

  loadClients() {
    fetch('clients/getAll', {
      method: 'POST'
    }).then(results => {
      return results.json();
    }).then(data => {
        let clients = data.clients
        let clientsSelect: any[] = []
        clients.map((client:any) => {
          clientsSelect.push(Object.assign(new Client(client), {value:client.id, label:client.name}))
        })
        this.setState({clients: clientsSelect})
    }).catch(err => {
      toast.error(err.message);
    })
  }

  loadAdmins() {
    fetch('admins/getAll', {
      method: 'POST'
    }).then(results => {
      return results.json();
    }).then(data => {
        let admins = data.admins
        let adminsSelect: any[] = []
        admins.map((admin:any) => {
          adminsSelect.push({new:true, id: admin.id, value:admin.id, label:admin.name})
        })
        this.setState({admins: adminsSelect})
    }).catch(err => {
      toast.error(err.message);
    })
  }

  loadCategories() {
    fetch('categories/getAll', {
      method: 'POST'
    }).then(results => {
      return results.json();
    }).then(data => {
        let categories = data.categories
        let categoriesSelect: any[] = []
        categories.map((category:any) => {
          categoriesSelect.push({value:category.id, label:category.title})
        })
        this.setState({categories: categoriesSelect})
    }).catch(err => {
      toast.error(err.message);
    })
  }

  loadUsers() {
    fetch('users/getAll', {
      method: 'POST'
    }).then(results => {
      return results.json();
    }).then(data => {
        let users = data.users
        let usersSelect: any[] = []
        users.map((user:any) => {
          usersSelect.push(Object.assign(new User(user), {value:user.id, label:user.name, price: user.price}))
        })
        this.setState({users: usersSelect})
    }).catch(err => {
      toast.error(err.message);
    })
  }


  logoChange(input: any) {
    let file = this.logo.files[0]
     var reader = new FileReader();
     let campaign = this.state.campaign
     campaign.updated = false
     reader.onload = (e: any) => {
       if(e.target) {
         this.setState({logo: e.target.result, campaign})
       }
     }
     reader.readAsDataURL(file);
  }

  renderCellInput(celldata: any) {
    return <input readOnly={window.account.type != "admin"} className="priceInput" name={celldata.column.id} onChange={controller.editCampaignUser.bind(this, celldata.value.id)} type="text" value={celldata.value[celldata.column.id] || ""} placeholder="" />
  }

  public render() {
    let campaign = this.state.campaign
    let client = campaign && campaign.client
    let url = this.state.logo.length? this.state.logo : process.env.REACT_APP_AWS+"/campaigns/"+campaign.id+"/logos/"+campaign.logo

    const usersColumns = [{
      id: "name",
      Header: this.props.translate("name").toString(),
      accessor: (d:any) => d,
      Cell: (row:any) => <Link to={`/users/${row.value.id}`}><div className={"status " +row.value.participating}>{row.value.name}</div></Link>
    }, {
      id: "followers",
      Header: this.props.translate("followers").toString(),
      maxWidth: 80,
      resizable: false,
      sortable: true,
      accessor: (d:any) => d,
      Cell: (row:any) => <input readOnly={true} className="priceInput" value={row.value[campaign.mediaType+"Followers"]} />

    }, {
      id: "views",
      Header: this.props.translate("campaign.views").toString(),
      maxWidth: 80,
      resizable: false,
      sortable: true,
      accessor: (d:any) => d,
      Cell: this.renderCellInput

    }, {
      id: "videoViews",
      Header: this.props.translate("campaign.videoViews").toString(),
      maxWidth: 80,
      resizable: false,
      sortable: true,
      accessor: (d:any) => d,
      Cell: this.renderCellInput

    }, {
      id: "likes",
      Header: this.props.translate("campaign.likes").toString(),
      maxWidth: 80,
      resizable: false,
      sortable: true,
      accessor: (d:any) => d,
      Cell: this.renderCellInput
    }, {
      id: "comments",
      Header: this.props.translate("campaign.comments").toString(),
      maxWidth: 80,
      resizable: false,
      sortable: true,
      accessor: (d:any) => d,
      Cell: this.renderCellInput
    }, {
      id: 'price',
      Header: this.props.translate("campaign.price").toString(),
      show: window.account.type == "admin",
      sortable: true,
      maxWidth: 80,
      accessor: (d:any) => d,
      Cell: this.renderCellInput
    }, {
      id: 'more',
      Header: this.props.translate("campaign.more").toString(),
      accessor: (d:any) => d,
      Cell: this.renderCellInput
    },
    {
      Header: this.props.translate("newMedia").toString(),
      resizable: false,
      maxWidth: 80,
      accessor: 'newMedia'
    },
    {
      Header: this.props.translate("mediaToApprove").toString(),
      show: window.account.type == "admin",
      resizable: false,
      maxWidth: 80,
      accessor: 'mediaToApprove'
    },{
      id: 'settings',
      Header: this.props.translate("settings").toString(),
      sortable: false,
      resizable: false,
      accessor: (d:any) => d,
      Cell: (row:any) => <div>
        {row.value.campaignUserId && <i className="fas fa-images" onClick={this.openPopup.bind(this, "campaignUserPopupOpen", row.value.id)}></i>}
        {row.value.campaignUserId && <i className="fas fa-link"   onClick={this.openPopup.bind(this, "campaignUserLinksPopupOpen", row.value.id)}></i>}
        {window.account.type == "admin" && <i onClick={controller.removeUser.bind(this, row.value.campaignUserId, row.value.id, row.index)} className="fas fa-trash-alt"></i>}
      </div>
    }]

    return (
      <div id="edit-campaign-root">

          {this.state.campaignUserPopupOpen &&
            <CampaignUser
              closePopup={this.closePopup.bind(this)}
              campaignId={this.state.campaign.id}
              userId={this.state.userId}/>}

          {this.state.campaignUserLinksPopupOpen &&
              <CampaignUserLinks
                  closePopup={this.closePopup.bind(this)}
                  campaignId={this.state.campaign.id}
                  userId={this.state.userId}/>}

          {campaign.id && <div className="campaignStatus">
            <span><div className={campaign.status}></div></span>
            <span><Translate id="campaign.id" />: {campaign.id}</span>
          </div>}
          <Link to="/campaigns"><i className="fas fa-times"></i></Link>
          <form className="data">
            {((campaign.id && campaign.logo.length) || (this.state.logo.length))?
              (<div className="picture" style={{backgroundImage: "url("+url+")"}} onClick={() => {this.logo.click()}}></div>)
            : (<div className="picture" onClick={() => {this.logo.click()}}></div>)}
            <input onChange={this.logoChange.bind(this, this.logo)} style={{"display":"none"}} ref={el => this.logo = el} name="logo" type="file" />

            <div className="third inputC">
            <label><Translate id="campaign.type" /></label>
            <Select
              value={campaign.mediaType && {value: campaign.mediaType, label: MediaType[campaign.mediaType]}}
              onChange={controller.changeMediaType.bind(this)}
              options={this.state.mediaTypes}
              menuPlacement={"bottom"}
              placeholder={this.props.translate("campaign.type").toString()}
              theme={themeStyles}
              styles={customSelectStyles}
              className="multiSelect"
              classNamePrefix="react-select"
              isRtl={(this.props.activeLanguage && this.props.activeLanguage.code == "he") ? true : false}
            /></div>

            <div className="third inputC">
            <label><Translate id="client" /></label>
            <Select
              value={client && {value: client.id, label: client.name}}
              onChange={controller.changeClient.bind(this)}
              options={this.state.clients}
              menuPlacement={"bottom"}
              placeholder={this.props.translate("client").toString()}
              theme={themeStyles}
              styles={customSelectStyles}
              className="multiSelect"
              classNamePrefix="react-select"
              isRtl={(this.props.activeLanguage && this.props.activeLanguage.code == "he") ? true : false}
            /></div>

            <div className="third inputC">
              <label><Translate id="campaign.name" /></label>
              <input onChange={this.handleCampaignChange.bind(this)} name="title" defaultValue={campaign.title} placeholder="לדוגמה: הגלידה החדשה של שטראוס" />
            </div>

            <div className="third inputC">
            <label><Translate id="campaign.deadline" /></label>
            <DatePicker
              selected={campaign.deadline.toDate()}
              onChange={controller.changeDate.bind(this, "deadline")}
              name="deadline"
              dateFormat="dd/MM/yyyy"
              autoComplete="off"
            /></div>
            <div className="third inputC">
            <label><Translate id="campaign.start" /></label>
            <DatePicker
              selected={campaign.startDate.toDate()}
              onChange={controller.changeDate.bind(this, "startDate")}
              name="startDate"
              dateFormat="dd/MM/yyyy"
              autoComplete="off"
            /></div>
            <div className="third inputC">
            <label><Translate id="campaign.end" /></label>
            <DatePicker
              selected={campaign.endDate.toDate()}
              onChange={controller.changeDate.bind(this, "endDate")}
              name="endDate"
              dateFormat="dd/MM/yyyy"
              autoComplete="off"
            /></div>

            <div className="third inputC">
              <label><Translate id="campaign.participents" /></label>
              <input onChange={this.handleCampaignChange.bind(this)} value={campaign.maxUsers} name="maxUsers" placeholder="0" />
            </div>


            <div className="third inputC">
            <label><Translate id="campaign.admins" /></label>
            <Select
              onChange={controller.handleAdminChange.bind(this)}
              options={this.state.admins}
              menuPlacement={"bottom"}
              placeholder={this.props.translate("campaign.searchAdmins").toString()}
              isMulti
              isRtl={(this.props.activeLanguage && this.props.activeLanguage.code == "he") ? true : false}
              isClearable={false}
              theme={themeStyles}
              styles={customSelectStyles}
              className="multiSelect"
              classNamePrefix="react-select"
              value={campaign.admins}
            /></div>


            <div className="third inputC">
            <label><Translate id="campaign.hashtags" /></label>
            <Creatable
              components={{DropdownIndicator: null}}
              menuIsOpen={false}
              placeholder={this.props.translate("campaign.hashtags").toString()}
              isMulti
              isClearable
              isRtl={(this.props.activeLanguage && this.props.activeLanguage.code == "he") ? true : false}
              theme={themeStyles}
              styles={customSelectStyles}
              className="multiSelect"
              classNamePrefix="react-select"
              onKeyDown={controller.handleKeyDown.bind(this)}
              onInputChange={controller.handleInputChange.bind(this)}
              onChange={controller.handleTagChange.bind(this)}
              inputValue={this.state.tagValue}
              value={campaign.tags}
            /></div>

            <div className="full inputC">
              <label><Translate id="campaign.description" /></label>
              <textarea onChange={this.handleCampaignChange.bind(this)} name="description" value={campaign.description} placeholder={this.props.translate("campaign.descriptionExample").toString()}></textarea>
            </div>

            <div className="third inputC">
              <label><Translate id="campaign.brief" /></label>
              {campaign.brief.length? (
                <div><a target="_blank" className="primary-btn " href={process.env.REACT_APP_AWS+"/campaigns/"+campaign.id+"/briefs/"+campaign.brief}>
                  <i className="fas fa-file-pdf"></i><Translate id="campaign.downloadBrief" />
                </a>
                <a className="primary-btn red" onClick={controller.removeBrief.bind(this)}>
                  <i className="fas fa-trash-alt"></i><Translate id="campaign.deleteBrief" />
                </a>
                </div>
              ) : (
                <button style={{width:"100%"}} className="second-btn" onClick={(event:any) => {event.preventDefault(); this.brief.click()}}><i className="fas fa-file-pdf"></i>{this.state.brief? this.state.brief : this.props.translate("clickHere").toString()}</button>
              )}
            </div>

            <div className="full inputC">
              <label><Translate id="campaign.images" />:</label>
              {campaign.images.map((image:any, i:number) => {
                let url = image.id? process.env.REACT_APP_AWS+"/campaigns/"+campaign.id+"/images/"+image.url : image.url
                return <div key={i} className="imageC" style={{backgroundImage: "url("+url+")"}}>{image.id && <i onClick={controller.removeImage.bind(this, image.id, i)} className="fas fa-trash-alt"></i>}{image.id && <a href={url}><i className="fas fa-download"></i></a>}</div>
              })}
              <div className="imageC"><i className="fas fa-plus" onClick={() => {this.image.click()}}></i></div>
            </div>



            {window.account.type=="admin" && <div className="third"><Select
              onChange={controller.addUser.bind(this)}
              options={this.state.users}
              menuPlacement={"bottom"}
              placeholder={this.props.translate("campaign.addInfluncer").toString()}
              theme={themeStyles}
              styles={customSelectStyles}
              className="multiSelect"
              classNamePrefix="react-select"
              isRtl={(this.props.activeLanguage && this.props.activeLanguage.code == "he") ? true : false}
            /></div>}
            <input className="search third" type="text" placeholder={this.props.translate("campaign.searchInfluncer").toString()} onChange={this.search.bind(this)} ref={(searchString:any) => this.searchString = searchString} />
            {window.account.type=="admin" && <div className="third half"><Select
              onChange={controller.filterInfluncers.bind(this)}
              options={this.state.categories}
              value={this.state.selectedCategory && {value: this.state.selectedCategory.id, label: this.state.selectedCategory.title}}
              menuPlacement={"bottom"}
              placeholder={this.props.translate("campaign.filterInfluncers").toString()}
              theme={themeStyles}
              styles={customSelectStyles}
              className="multiSelect"
              classNamePrefix="react-select"
              isRtl={(this.props.activeLanguage && this.props.activeLanguage.code == "he") ? true : false}
            /></div>}
            {window.account.type=="admin" && <div className="third half"><Select
              onChange={controller.addInfluncerByCategory.bind(this)}
              options={this.state.categories}
              value={this.state.selectedCategory && {value: this.state.selectedCategory.id, label: this.state.selectedCategory.title}}
              menuPlacement={"bottom"}
              placeholder={this.props.translate("campaign.addInfluncerByCategory").toString()}
              theme={themeStyles}
              styles={customSelectStyles}
              className="multiSelect"
              classNamePrefix="react-select"
              isRtl={(this.props.activeLanguage && this.props.activeLanguage.code == "he") ? true : false}
            /></div>}
            <div className="clearfix"></div>
            <ReactTable
              data={this.state.usersFiltered}
              columns={usersColumns}
              defaultPageSize={5}
              noDataText={this.props.translate("noResults").toString()}
              nextText={this.props.translate("next").toString()}
              previousText={this.props.translate("previous").toString()}
              rowsText={this.props.translate("rows").toString()}
              pageText={this.props.translate("page").toString()}
              ofText={this.props.translate("of").toString()}
              style={{
                height: "400px",
                textAlign: "center",
                fontSize: "1em",
                position: "centner",
                right: "0",
                left: "0",
                margin: "0 auto",
                color: "#242424"
              }}
              className="-striped -highlight reactTable"
            />

            {window.account.type=="admin" && <h6><Translate id="total" /> ₪{campaign.totalPrice}</h6>}

            <input ref={el => this.image = el} onChange={controller.addImage.bind(this)} style={{display: "none"}} name="image" type="file" />
            <input ref={el => this.brief = el}  accept="application/pdf" onChange={controller.addBrief.bind(this)} style={{display: "none"}} name="brief" type="file" />

            <button className={"update "+((campaign.id && campaign.updated)? "updated" : "")} onClick={this.updateCampaign} disabled={campaign.updated || this.state.updating}>
            {this.state.updating? this.props.translate("updating").toString() :
              campaign.id? campaign.updated? this.props.translate("updated").toString() :
              this.props.translate("update").toString() :
              this.props.translate("save").toString()}
            </button>
            {window.account.type=="admin" && campaign.status == "pending" && <button onClick={controller.activeCampaign.bind(this)} className="primary-btn green"><Translate id="campaign.active" /></button>}
            {window.account.type=="admin" && campaign.status == "active" && <button onClick={controller.completeCampaign.bind(this)} className="primary-btn green"><Translate id="campaign.complete" /></button>}
            <br/>
            <button onClick={controller.exportCampaign.bind(this)} className="primary-btn green"><Translate id="export" /></button>
          </form>
        </div>
    )
  }
}

export default withLocalize(CampaignPage)



// WEBPACK FOOTER //
// ./src/pages/campaign/Campaign.tsx